import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-t2-sidebar',
  templateUrl: './t2-sidebar.component.html',
  styleUrls: ['./t2-sidebar.component.scss']
})
export class T2SidebarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/trip2-theme/components/t2-sidebar/t2-sidebar.component.ts